import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, combineReducers } from "redux";
import { TableWrapper, Badge, Filters, SliderOverlay, ConfirmModal, ToggleCheckbox } from "../../component/common/"
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { getSNo } from "../../services/helperFunctions"

import { getActivityListDetails, deleteActivity, changeActivityStatus } from "../../redux/actions/activity"

import { LoaderWrapper } from "../../HOC"



class activityClass extends Component {

	state = {
		activityLists: [],
		headerDetails: [
			{
				label: 'S.No',
			},
			{
				label: 'Image',
			},
			{
				label: 'Title',
			},
			{
				label: 'Ticket Count',
			},
			{
				label: 'Status',
			},
			{
				label: "Change Status"
			},
			{
				label: 'Action'
			},

		],
		filter: [


			{
				label: 'Active',
				value: 1
			},
			{
				label: 'Deactive',
				value: 4
			}

		],
		activityStatusChange: {
			activityId: "",
			status: null
		},

		selectedFilter: 'Active',
		ConfirmModalOpenStatus: false,
		ConfirmModalChangeActiveStatus: false,
		deleteIndex: null
	}


	componentWillMount() {

	}

	componentDidMount() {
		this.setState({
			activityLists: this.props.activityLists
		})

	}

	requestStatus = (status) => {

		if (status === 1) {
			return <Badge
				type={1}
				label={"Active"}
			/>
		} else if (status === 0) {
			return <Badge
				type={2}
				label={"Inactive"}
			/>
		}

	}

	handleFilter = (query, value, name) => {

		if (name == "filter") {
			this.setState({
				selectedFilter: query
			})

			query = {
				page: 1,
				filter: query
			}
		}

		this.props.getActivityListDetails(query)



	}



	toggle = item => {
		this.setState(prevState => ({
			[item]: !prevState[item]
		}));
	}


	handleDeleteToggle = (deleteIndex) => {

		this.setState({
			deleteIndex
		})

		this.toggleDelete("ConfirmModalOpenStatus")

	}


	handleDelete = () => {
		let { deleteIndex } = this.state
		this.props.deleteActivity(deleteIndex).then(() => {

			this.props.getActivityListDetails()

			this.toggleDelete("ConfirmModalOpenStatus")

		})

		// this.props.deleteExperienceGroup(id).then(() => {

		// 	this.props.getActivityListDetails()

		// 	this.toggleDelete("ConfirmModalOpenStatus")

		// })

	}

	toggleStatusChange = (id, stat) => {
		console.log(id, stat);

		let activityStatusChange = {}
		activityStatusChange.activityId = id;
		activityStatusChange.status = stat
		this.setState({
			activityStatusChange
		})
		this.toggle('ConfirmModalChangeActiveStatus')
	}

	changeStatus = () => {

		const { activityStatusChange: { activityId, status } } = this.state
		const body = {
			activityId: activityId,
			status: status === 1 ? 0 : 1
		}
		console.log(activityId, status);
		this.props.changeActivityStatus(body).then(() => {
			this.props.getActivityListDetails()
			this.toggle('ConfirmModalChangeActiveStatus')
		})
	}

	toggleDelete = (name) => {
		this.setState({
			[name]: !this.state[name]
		})
	}


	handleNavigation = () => {
		let { history } = this.props
		history.push('/activity/create')
	}

	handleEdit = (id) => {
		let { history } = this.props
		history.push(`/activity/edit/${id}`)
	}

	handleView = (id) => {
		let { history } = this.props
		history.push(`/activity/view?id=${id}`)
	}






	render() {

		let { headerDetails, filter, selectedFilter, experienceGroupDetails, isError, isOpen, isEdit, ConfirmModalOpenStatus, ConfirmModalChangeActiveStatus } = this.state
		let { activityLists } = this.props
		let IsEmpty = activityLists.list.length > 0



		return (
			<div>
				<div className="sair-pg-header">
					<h4 className="sair-pg-title align-self-center">
						<span className="pg-title-icon">
							<span className="feather-icon">
								<svg
									xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" className="feather feather-align-left">
									<line x1="17" y1="10" x2="3" y2="10"></line>
									<line x1="21" y1="6" x2="3" y2="6"></line>
									<line x1="21" y1="14" x2="3" y2="14"></line>
									<line x1="17" y1="18" x2="3" y2="18"></line>
								</svg>
							</span>
						</span>Activity
					</h4>
					<div className="col-auto ">
						<button className="btn btn-primary btn-sm"
							onClick={() => this.handleNavigation()}
						>Add Activity</button>
					</div>
				</div>
				<section className="sair-sec-wrapper">
					<div className="row">
						<div className="col-sm">
							<div className="row no-gutters">
								<h5 className="sair-sec-title align-self-center">Activity List</h5>
								<div className="ml-auto d-flex align-items-center">
									{/* <UncontrolledDropdown setActiveFromChild className="filter-dropdown">
										<DropdownToggle tag="a" className="custom-caret dropdown-toggle-link">
											Filter by: {selectedFilter}
										</DropdownToggle>
										<DropdownMenu>
											{filter.map(({ label, value }, index) => {
												return (
													<DropdownItem
														onClick={e => this.handleFilter(label, value, "filter")}
														key={index}
													>
														{label}
													</DropdownItem>

												)
											})}
										</DropdownMenu>
									</UncontrolledDropdown> */}

									<div className="search-box position-relative  ml-3">

										<Filters
											queryHandler={(query) => this.handleFilter(query)}
											isDropDownFilter={false}
										/>
									</div>
								</div>
							</div>
							<div className="table-wrap mt-3">
								<TableWrapper
									headerDetails={headerDetails}
									isEmpty={IsEmpty}
									pageMeta={activityLists.pageMeta}
									queryHandler={(query) => this.handleFilter(query)}


								>
									{activityLists.list.map((item, index) => {
										let { id, title, status, ActivityImage, ticket_count } = item

										return (
											<tr
												key={index}  >
												<td>{getSNo(activityLists.pageMeta, index)}</td>
												<td>
													{ActivityImage ?
														<img src={ActivityImage.imageUrl} style={{ width: '100px' }} />
														: "-"}
												</td>
												<td>{title}</td>
												<td>{ticket_count}</td>
												<td>{this.requestStatus(status)}</td>
												<td><ToggleCheckbox value={status} onClick={() => this.toggleStatusChange(id, status)} /></td>
												<td>
													<a className="mr-25"
														onClick={e => this.handleView(id)}
													>
														<i className="icon-eye text-primary"></i>
													</a>
													<a className="mr-25"
														onClick={e => this.handleEdit(id)}
													>
														<i className="icon-pencil  text-primary cursor-pointer"
														></i>
													</a>
													<a ><i
														className="icon-trash txt-danger text-primary cursor-pointer"
														onClick={e => this.handleDeleteToggle(id)}
													></i></a>
												</td>

											</tr>

										)

									})}


								</TableWrapper>
							</div>
						</div>
					</div>
				</section>

				<ConfirmModal
					isOpen={ConfirmModalChangeActiveStatus}
					keyName="ConfirmModalChangeActiveStatus"
					toggle={() => {
						let { activityStatusChange } = this.state
						activityStatusChange.activityId = null;
						activityStatusChange.status = null;
						this.setState({
							activityStatusChange
						}, () => this.toggle('ConfirmModalChangeActiveStatus'))
					}}
					handleSubmit={() => this.changeStatus()}
				>
					<h5>Are you sure you want to change the Activity's status?</h5>
				</ConfirmModal>

				<ConfirmModal
					keyName="ConfirmModalOpenStatus"
					toggle={this.toggle}
					isOpen={ConfirmModalOpenStatus}
					handleSubmit={() => this.handleDelete()}
					submitText='Delete'
				>
					<h5>
						Are you sure want to delete Activity?
					</h5>
				</ConfirmModal>

			</div>
		)
	}
}

const mapStateToProps = state => {

	return {
		activityLists: state.activity.activityLists

	}


};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		getActivityListDetails,
		changeActivityStatus,
		deleteActivity
	}, dispatch)
};

let actions = ['getActivityListDetails']

let component = LoaderWrapper(activityClass)({ actions })



export const Activity = connect(mapStateToProps, mapDispatchToProps)(component)

